// Exercise section — mirrors DayLog's detail view for logged workouts.
// Shows the selected day's total NET calories burned + a list of activities
// (activity · duration · intensity → kcal). The date is driven by DayLog's
// date navigation (shared refetch), so this card always reflects the same day.
//
// Sparse feature: DashboardApp only mounts this card when the user has ANY
// exercise data. When mounted but the selected day has none, it shows an empty
// state — so it always renders cleanly regardless of how little data exists.

import type { DashboardDay } from '../lib/types'
import type { Strings } from '../lib/i18n'

interface Props {
  day: DashboardDay
  strings: Strings
}

export function ExerciseCard({ day, strings: s }: Props) {
  const ex = day.exercise

  return (
    <div className="dash-card dash-exercise-card">
      <div className="dash-card-title">{s.exerciseTitle}</div>

      <div className="exercise-total">
        <span className="exercise-total-val">{Math.round(ex.total_calories)}</span>
        <span className="exercise-total-unit">{s.kcalUnit}</span>
        <span className="exercise-total-label">{s.exerciseBurnedLabel}</span>
      </div>

      {ex.entries.length === 0 ? (
        <p className="daylog-empty">{s.exerciseNoLog}</p>
      ) : (
        <div className="exercise-list">
          {ex.entries.map((e, i) => {
            const meta = [
              s.fmtDuration(e.duration_min),
              e.intensity || null,
              e.distance != null && e.distance > 0
                ? `${e.distance}${e.distance_unit ?? ''}`
                : null,
            ].filter(Boolean).join(' · ')
            return (
              <div key={i} className="exercise-item">
                <div className="exercise-item-main">
                  <span className="exercise-item-activity">
                    {e.activity || s.exerciseDefaultActivity}
                  </span>
                  <span className="exercise-item-kcal">
                    {Math.round(e.calories)} {s.kcalUnit}
                  </span>
                </div>
                {meta && <div className="exercise-item-meta">{meta}</div>}
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
